import { partsOf, fromParts, daysInMonth, toIsoDay, today } from '../../../tools/calendars';

// The ready-made time frames of the packing list filter ("Today", "Last 7 days", "This month" ...).
//
// A month and a year are the ones of the CALENDAR the person is working in: "This month" is the Shamsi month under the
// Shamsi calendar and the Hijri month under the Hijri one. Everything handed back is a plain Gregorian 'YYYY-MM-DD'
// pair - what the API searches on - so a frame is the same days whichever calendar it was picked in.

const DAY = 24 * 60 * 60 * 1000;
const addDays = (d, n) => new Date(d.getTime() + n * DAY);

export function timeFramePresets(system) {
  const now = today();
  const iso = toIsoDay;
  const p = partsOf(now, system);
  const first = (year, month) => fromParts({ year, month, day: 1 }, system);
  const last = (year, month) => fromParts({ year, month, day: daysInMonth(year, month, system) }, system);
  const before = p.month === 1 ? { year: p.year - 1, month: 12 } : { year: p.year, month: p.month - 1 };
  const frames = [
    { key: 'today', labelKey: 'mis.plPresetToday', from: now, to: now },
    { key: 'yesterday', labelKey: 'mis.plPresetYesterday', from: addDays(now, -1), to: addDays(now, -1) },
    { key: 'last7', labelKey: 'mis.plPresetLast7', from: addDays(now, -6), to: now },
    { key: 'last30', labelKey: 'mis.plPresetLast30', from: addDays(now, -29), to: now },
    { key: 'thisMonth', labelKey: 'mis.plPresetThisMonth', from: first(p.year, p.month), to: last(p.year, p.month) },
    { key: 'lastMonth', labelKey: 'mis.plPresetLastMonth', from: first(before.year, before.month), to: last(before.year, before.month) },
    { key: 'thisYear', labelKey: 'mis.plPresetThisYear', from: first(p.year, 1), to: last(p.year, 12) },
  ];
  return frames.filter((f) => f.from && f.to).map((f) => ({ ...f, from: iso(f.from), to: iso(f.to) }));
}

// Which frame is the current range? 'any' (nothing set), one of the presets' keys, or 'custom' (typed dates).
export function activeTimeFrame(presets, from, to) {
  if (!from && !to) return 'any';
  const hit = presets.find((f) => f.from === from && f.to === to);
  return hit ? hit.key : 'custom';
}
